export const declarationMap: GenericObject = {
	declaration_path: "declarationPath",
};
